// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__d4gnP","title":"styles_title__2CKN-","placeholderBox":"styles_placeholderBox__qAnzk"};